import { StyleSheet, Dimensions } from 'react-native'

const { height: SCREEN_HEIGHT, width: SCREEN_WIDTH } = Dimensions.get('window')

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    maxHeight: SCREEN_HEIGHT * 0.8,
    width: SCREEN_WIDTH * 0.92,
    maxWidth: 560,
    alignSelf: 'center',
    overflow: 'hidden',
    padding: 8
  },

  scrollArea: {
    flex: 1,
    maxHeight: SCREEN_HEIGHT * 0.5,
    overflow: 'hidden'
  },

  scrollView: {
    flex: 1
  },

  scrollContent: {
    paddingVertical: 8,
    gap: 8
  },

  listItem: {
    backgroundColor: '#E0E0E0',
    borderRadius: 4,
    marginBottom: 8
  },

  buttonArea: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 8,
    paddingTop: 12,
    flexShrink: 0
  },

  content: {
    gap: 8
  }
})